export default __webpack_public_path__ + "sounds/framework/wrongBuzzer_R.9e27f269.mp3?9e27f269";